import xhr from '../../Xhr';

const API = (id) => ({
  log: {
    payLog: {
      url: process.env.REACT_APP_API + `/v1/user/${id}/transaction`,
      method: 'GET'
    },
    loginLog: {
      url: process.env.REACT_APP_API_SERVER + `/v1/vdn/${id}/login_log`,
      method: 'GET'
    }
  }
})

export const fetchPayLog = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).log.payLog,
    action: 'PAYLOG'
  })
}

export const fetchLoginLog = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).log.loginLog,
    action: 'LOGINLOG'
  })
}


// WEBPACK FOOTER //
// ./src/modules/log/actions.js